import { useState } from "react";
import { Upload } from "lucide-react";

const FileUploader = ({ fileInputRef, handleFiles }) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFiles(droppedFiles);
  };

  const handleFileInput = (e) => {
    const selectedFiles = Array.from(e.target.files);
    handleFiles(selectedFiles);
  };

  return (
    <div
      className={`relative border-2 border-dashed rounded-xl p-6 text-center transition-all duration-300 cursor-pointer
            ${
              isDragOver
                ? "border-blue-500 bg-blue-50 scale-105"
                : "border-gray-300 hover:border-blue-400 hover:bg-gray-50"
            }`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => fileInputRef.current?.click()}
    >
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*,.pdf"
        onChange={handleFileInput}
        className="hidden"
      />

      <div className="flex flex-col items-center space-y-4">
        <div
          className={`p-4 rounded-full transition-colors duration-300 ${
            isDragOver ? "bg-blue-100" : "bg-gray-100"
          }`}
        >
          <Upload
            className={`w-12 h-12 transition-colors duration-300 ${
              isDragOver ? "text-blue-600" : "text-gray-500"
            }`}
          />
        </div>

        <div>
          <p className="text-xl font-semibold text-gray-700 mb-2">
            {isDragOver ? "Drop files here" : "Choose files or drag them here"}
          </p>
          <p className="text-sm text-gray-500">
            Supports: JPG, PNG, GIF, WEBP, PDF (Max 10MB each)
          </p>
        </div>
      </div>
    </div>
  );
};

export default FileUploader;
